<template>
  <div>Logofff</div>
</template>

<script>
import api from "../services/api";
export default {
  name: "Logoff",
  mounted() {
    api.logoff();
  },
};
</script>

<style></style>
